import PropTypes from 'prop-types';

import { ITALIC_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { ITALIC_TAG_NAME } from './constants';

const renderer = ({
  node: { type },
  ITALIC_TAG = ITALIC_TAG_NAME,
  ...attributes
}) => {
  if (type === ITALIC_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return <ITALIC_TAG {...restOfAttributes}>{children}</ITALIC_TAG>;
  }
};

renderer.propTypes = {
  className: PropTypes.string,
  ITALIC_TAG: PropTypes.node,
  text: PropTypes.string,
};

export { renderer };
